export default __webpack_public_path__ + "static/media/tribe-bali-kuta-beach-slider.86034b6b.jpg";